import React from "react";
import FrontAbstract from "./../assets/journals/frontabstract.jpg";
import BackField from "./../assets/journals/backfield.jpg";
import { PrimaryButtonWithIcon } from "./Buttons";

const StoreCTA = () => {
  return (
    <div className="bg-cream mt-24 md:py-24 md:px-20 px-8 py-12">
      <div className="flex justify-center items-center flex-col md:flex-row gap-8">
        <div className="flex gap-8">
          <img
            src={FrontAbstract}
            alt="Abstract shape journal"
            className="md:w-64 w-32 rounded-md"
          />
          <img
            src={BackField}
            alt="But the field journal"
            className="md:w-64 w-32 rounded-md"
          />
        </div>
        <div className="md:w-1/2 w-full">
          <h3 className="text-3xl text-dark-blue font-bold">
            Get a copy of The 360 Believer Journal
          </h3>
          <p className="mt-4 text-gray-600 text-justify">
            Our customized journal will come in handy to help you retain points
            from your personal Bible study, capture notes from your church
            service, maximize the teachings at special camp meetings, write down
            words of prophecies and even the ideas God has placed in your heart.
          </p>
          <div className="mt-4">
            <PrimaryButtonWithIcon
              btnText={"Visit Store"}
              url="/store"
              icon={<i className="bi bi-cart-check"></i>}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreCTA;
